<div id="main-wrapper">
  <router-outlet></router-outlet>
</div>

<!-- Tutoriales guiados (SCG-368): una sola instancia, fuera del router-outlet. -->
<app-guided-tour-overlay></app-guided-tour-overlay>

<div class="loader" *ngIf="loaderService.isLoading | async">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>